import * as z from "zod";

const shortfallCounts = z.object({
  total: z.number(),
  handoff: z.number(),
  detectedHandoff: z.number(),
  directToSupport: z.number(),
  supervisorForced: z.number(),
  noKnowledge: z.number(),
  emptySearch: z.number(),
});

export const getShopperAgentShortfallCounts = {
  name: "getShopperAgentShortfallCounts" as const,
  input: z.object({ start: z.date(), end: z.date() }),
  output: z.object({
    current: shortfallCounts,
    /** The window of the same length that ends where this one starts. */
    previous: shortfallCounts,
    /** Every skill some shortfall in the window had available. */
    skills: z.array(z.string()),
  }),
};
